import React, { useState, useCallback, useEffect } from "react";
import { Container, Label, ContentFlex, LabelContent } from "./styles";
import { Dropdown } from "semantic-ui-react";
import { producaov2 as api } from "../../../services/apis";
import { RenderIf } from "../../RenderIf";

function AlunoSearchInput({
  handleChange,
  initiateValue,
  remove,
  hideLabel = false,
  naoAllIn,
  selectedAlunos,
  setSelectedAlunos,
  ...props
}) {
  console.log({ initiateValue })
  const [alunosOptions, setAlunosOptions] = useState([]);
  const [alunoSearch, setAlunoSearch] = useState("");
  const [selectedCursos, setSelectedCursos] = useState([])
  

  const handleAlunoSearchChange = useCallback((e) => {
    const search = e.target.value;
    setAlunoSearch(search);

    const cleanSearch = search.trim();

    api
      .get(
        `alunos?search=${cleanSearch}&limit=15&${naoAllIn ? "" : "all_in=true"}`
      )
      .then((res) => {
        if (res.data.length > 0) {
          const options = res.data.map((pessoa) => ({
            key: pessoa.id,
            text: `(${pessoa.email}) [ID: ${pessoa.id}]`,
            value: pessoa.id,
          }));
          setAlunosOptions(options);
        } else {
          setAlunosOptions([]);
        }
      });
  }, []);

  const handleRemoveAluno = (id) => {
    setSelectedAlunos((prev) => prev.filter((item) => item.id !== id));
  };

  useEffect(() => {
    handleAlunoSearchChange({ target: { value: "" } }); // Clear search initially
  }, []);

  useEffect(() => {
    if(initiateValue) {
      setSelectedAlunos(initiateValue)
    }
  }, [initiateValue])

  return (
    <Container>
      <div>
        <RenderIf isTrue={!hideLabel}>
          <Label>Selecione o aluno</Label>
          {selectedAlunos && (
            <ContentFlex>
              {selectedAlunos.map((elem, index) => {
                return (
                  <LabelContent
                    key={index}
                    title="remover"
                    onClick={() => handleRemoveAluno(elem.id)}
                  >
                    <p>{`(${elem.email}) [ID: ${elem.id}] X`}</p>
                  </LabelContent>
                );
              })}
            </ContentFlex>
          )}
        </RenderIf>
        <Dropdown
          placeholder="Busque pelo ID, Nome ou E-mail do aluno"
          fluid
          multiple
          search
          selection
          options={alunosOptions}
          onChange={handleChange}
          searchQuery={alunoSearch}
          onSearchChange={handleAlunoSearchChange}
          selectedCursos={selectedCursos}
          setSelectedCursos={selectedCursos}
          value={[0]}
        />
      </div>
    </Container>
  );
}

export default AlunoSearchInput;
